function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
import store from '../redux/store';
import { signup } from '../redux/actions/signupActions';
import { login } from '../redux/actions/authActions';
import { sendResetPasswordEmail } from '../redux/actions/userActions';
import { fetchResetPassword } from '../redux/actions/resetPasswordActions';
import { setUserConfig } from '../redux/actions/userActions';
import { closeKYCSidePane } from '../redux/actions/sidePaneActions';
var APEXWebActions = function APEXWebActions() {
  _classCallCheck(this, APEXWebActions);
  this.login = function (payload) {
    return store.dispatch(login(payload));
  };
  this.resetPassword = function (payload) {
    return store.dispatch(fetchResetPassword(payload));
  };
  this.sendResetPasswordEmail = function (UserName) {
    return store.dispatch(sendResetPasswordEmail(UserName));
  };
  this.signup = function (payload) {
    return store.dispatch(signup(payload));
  };
  this.setUserConfig = function (UserId, UserName, Config) {
    var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return store.dispatch(setUserConfig(UserId, UserName, Config, getUserConfigAfterSetUserConfig));
  };
  this.closeKYCSidePane = function () {
    return store.dispatch(closeKYCSidePane());
  };
  window.APEXWebActions = this;
};
export default function initAPEXWebActions() {
  new APEXWebActions();
}